module.exports = __webpack_public_path__ + "img/CV.3a4bffe2.svg";